const getLowResLink = (link = "") => {
  const linkSplitted = link.split("/");
  const lastValue = linkSplitted.pop();
  linkSplitted.push(`low-${lastValue}`);
  return linkSplitted.join("/");
};

export default getLowResLink;
